import React, { memo } from "react";

import { PopoverText } from '../../common/parts/PopoverText';
import { CourceRadio } from "../parts/CourceRadio";

export const FormCourceJunkai = memo((props) => {
  const { junkai_cources } = props;

  return (
    <>
      <p className="h3">巡回コースの選択 
        <PopoverText textTitle="まずコースを選択してください" textBody="コースはご年齢やその他の条件によって選択できるコースを表示しています。表示さていないコースは選択できません。" />
      </p>
      <div className="list-group mb-4">
        {junkai_cources.map(item => 
          <CourceRadio key={item.id} item={item} />
        )}
      </div>
    </>
  );
});